import DragEditTable from '@/components/DragEditTable'
import { Button, Form, Input, message, Spin, Tooltip } from 'antd'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { SActionBtn, STableActions } from 'shj-components'
import { queryHouseInfo, quoteBudgetInitQuoteBudgetItem } from '@/services/order.ts'
import { isEmpty, uniqueId } from 'lodash-es'

const Step2 = forwardRef((props: any, ref) => {
  const {
    query = {},
    isEdit = false,
    // couldOperate = true,
    spaceQuoteBudgetItemList = [],
    changeFormValue = () => {},
    detailInfo = {},
  } = props
  const [currenValue, setCurrenValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState([])
  useEffect(() => {
    initFn()
  }, [])

  const initFn = () => {
    if (!query?.quoteGoodsId && !isEdit) return
    if (!isEdit) {
      setDataSource(spaceQuoteBudgetItemList?.map(item => ({ ...item, key: uniqueId() }) || []))
    } else {
      setLoading(true)
      const apiUrl = queryHouseInfo
      apiUrl({ [isEdit ? 'params' : 'data']: query })
        .then(res => {
          setDataSource(res.map(item => ({ ...item, key: uniqueId() })))
        })
        .finally(() => setLoading(false))
    }
  }

  useImperativeHandle(ref, () => {
    return {
      data: dataSource,
    }
  }, [dataSource])

  // 编辑
  const onEdit = (record: any) => {
    record.status = 'edit'
    setCurrenValue(record.showName)
    handleCell(record)
  }
  // 删除
  const onDelete = (record: any) => {
    const newData = [...dataSource]
    newData.splice(
      newData.findIndex(item => item.key === record.key),
      1
    )
    setDataSource(newData)
  }
  // 取消
  const onCancel = record => {
    record.status = 'text'
    handleCell(record)
  }
  // 保存
  const onSave = record => {
    if (!currenValue) return message.error('显示名称不能为空')
    const hasSameName = dataSource?.filter(
      (data: any) => data.showName === currenValue && data.key !== record.key
    )
    if (hasSameName?.length) {
      message.error('显示名称不能重复')
      return
    }
    record.status = 'text'
    record.showName = currenValue
    handleCell(record)
  }
  // 复制
  const onCopy = record => {
    const newData = [...dataSource]
    const newRecord = {
      ...record,
      spaceRefId: record.id,
      copyFlag: false,
      addFlag: true,
      id: undefined,
    }
    newRecord.key = `${new Date().getTime()}`
    record.copyNumber = (record.copyNumber || 0) + 1
    newRecord.showName = (record.showName || '') + record.copyNumber
    newData.splice(newData.findIndex(item => item.key === record.key) + 1, 0, newRecord)
    setDataSource(newData)
  }
  // 统一处理单元格操作
  const handleCell = record => {
    const newData = dataSource?.map((data: any) => ({ ...data, status: 'complete' }))
    newData.splice(
      newData.findIndex(item => item.key === record.key),
      1,
      record
    )
    changeFormValue(newData)
    setDataSource(newData)
  }
  const handleRender = (text, record) => {
    // 仅查看
    if (record.status === 'edit') {
      return (
        <STableActions>
          <SActionBtn onClick={() => onCancel(record)}>取消</SActionBtn>
          <SActionBtn onClick={() => onSave(record)}>保存</SActionBtn>
        </STableActions>
      )
    } else {
      return (
        <STableActions>
          <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
          {(isEmpty(detailInfo) || (detailInfo?.state === 'budgetDraft' && !detailInfo?.frozenFlag)) && (
              <>
                {!record.spaceRefType && record.addFlag && (
                  <SActionBtn danger title="确认删除?" onClick={() => onDelete(record)}>
                    删除
                  </SActionBtn>
                )}
                {!record.spaceRefType && !record.addFlag && record.copyFlag && (
                  <SActionBtn onClick={() => onCopy(record)}>复制</SActionBtn>
                )}
              </>
            )}
        </STableActions>
      )
    }
  }
  const showNameRender = (text: any, record: any) => {
    if (record.status === 'edit') {
      return (
        <Input
          value={currenValue}
          maxLength={15}
          onChange={e => {
            setCurrenValue(e.target.value)
          }}
          autoFocus
        ></Input>
      )
    } else {
      return (
        <Tooltip title={record.showName}>
          <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
            {record.showName}
          </div>
        </Tooltip>
      )
    }
  }

  const showSpecValue = (text, record) => {
    const name =
      record?.spaceSpecParamValues?.filter((item: any) => item.id === text)?.[0]?.argValue ||
      record?.spaceSpecParamValueName
    return (
      <Tooltip title={name}>
        <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          {name}
        </div>
      </Tooltip>
    )
  }
  const columns: any = [
    { title: '空间类型', width: 160, dataIndex: 'spaceTypeName' },
    {
      title: '显示名称',
      dataIndex: 'showName',
      width: 160,
      render: (text, record) => showNameRender(text, record),
    },
    {
      title: '空间规格参数',
      dataIndex: 'spaceSpecParamName',
      width: 160,
    },
    {
      title: '规格值',
      dataIndex: 'spaceSpecParamValueId',
      width: 160,
      render: (text, record) => showSpecValue(text, record),
    },
    {
      title: '操作',
      dataIndex: 'handle',
      fixed: 'right',
      width: 170,
      render: (text, record) => handleRender(text, record),
    },
  ]

  return (
    <div>
      <Spin spinning={loading}>
        <DragEditTable
          rowKey="key"
          columns={columns}
          dataSource={dataSource}
          setDataSource={setDataSource}
        ></DragEditTable>
      </Spin>
    </div>
  )
})
export default Step2
